<div class="container">
    <h1>
        <i class="fa fa-users" aria-hidden="true"></i>&nbsp;
        {{ 'partners.pageHeaders.list' | translate}}
    </h1>

    <div class="filters-parent">
        <div class="filters">
            <label class="control-label" for="search">{{ 'partners.search' | translate}}</label>
            <input class="form-control input-filter" id="search" type="text" [(ngModel)]="search"
                   [placeholder]="'partners.filterBy' | translate" #searchInput>
        </div>
    </div>

    <div class="table-responsive">
        <table class="table table-striped table-hover">
            <thead>
            <tr>
                <th style="width: 35%;">{{ 'partners.name' | translate}}</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let partner of partners | filterByName:search">
                <td>
                    <a uiSref="partner-detail" [uiParams]="{ id: partner.id }">
                        {{partner.name}}
                    </a>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
    <button class="btn btn-primary btn-round btn-lg" uiSref="partner-create"> +</button>
</div>



// WEBPACK FOOTER //
// ./src/app/_screens/directory/partner/partner.component.html